import request from 'components/Utils/Request';
const { REACT_APP_API_URL } = process.env;

export const GET_LITIGATION_TYPES_DETAIL_LIST_REQUEST = 'GET_LITIGATION_TYPES_DETAIL_LIST_REQUEST';
export const GET_LITIGATION_TYPES_DETAIL_LIST_SUCCESS = 'GET_LITIGATION_TYPES_DETAIL_LIST_SUCCESS';
export const GET_LITIGATION_TYPES_DETAIL_LIST_FAILURE = 'GET_LITIGATION_TYPES_DETAIL_LIST_FAILURE';
export const ADD_LITIGATION_TYPES_MASTER_DETAIL_REQUEST = 'ADD_LITIGATION_TYPES_MASTER_DETAIL_REQUEST';
export const ADD_LITIGATION_TYPES_MASTER_DETAIL_SUCCESS = 'ADD_LITIGATION_TYPES_MASTER_DETAIL_SUCCESS';
export const ADD_LITIGATION_TYPES_MASTER_DETAIL_FAILURE = 'ADD_LITIGATION_TYPES_MASTER_DETAIL_FAILURE';
export const UPDATE_LITIGATION_TYPES_MASTER_DETAIL_REQUEST = 'UPDATE_LITIGATION_TYPES_MASTER_DETAIL_REQUEST';
export const UPDATE_LITIGATION_TYPES_MASTER_DETAIL_SUCCESS = 'UPDATE_LITIGATION_TYPES_MASTER_DETAIL_SUCCESS';
export const UPDATE_LITIGATION_TYPES_MASTER_DETAIL_FAILURE = 'UPDATE_LITIGATION_TYPES_MASTER_DETAIL_FAILURE';

  export const getLitigationTypeDetailListRequest = () => ({
    type: GET_LITIGATION_TYPES_DETAIL_LIST_REQUEST
  });
  export const getLitigationTypeDetailListSuccess = payload => ({
    type: GET_LITIGATION_TYPES_DETAIL_LIST_SUCCESS,
    payload
  });
  export const getLitigationTypeDetailListFailure = payload => ({
    type: GET_LITIGATION_TYPES_DETAIL_LIST_FAILURE,
    payload
  });

  export const addLitigationTypeMasterDetailRequest = () => ({
      type: ADD_LITIGATION_TYPES_MASTER_DETAIL_REQUEST
    });
    export const addLitigationTypeMasterDetailSuccess = payload => ({
      type: ADD_LITIGATION_TYPES_MASTER_DETAIL_SUCCESS,
      payload
    });
    export const addLitigationTypeMasterDetailFailure = payload => ({
      type: ADD_LITIGATION_TYPES_MASTER_DETAIL_FAILURE,
      payload
    });
  
    export const updateLitigationTypeMasterDetailRequest = () => ({
      type: UPDATE_LITIGATION_TYPES_MASTER_DETAIL_REQUEST
    });
    export const updateLitigationTypeMasterDetailSuccess = payload => ({
      type: UPDATE_LITIGATION_TYPES_MASTER_DETAIL_SUCCESS,
      payload
    });
    export const updateLitigationTypeMasterDetailFailure = payload => ({
      type: UPDATE_LITIGATION_TYPES_MASTER_DETAIL_FAILURE,
      payload
    });

  export const litigationTypeDetailAction = payload => {
    return {
      type: 'LITIGATIONTYPEDETAIL',
      payload
    };
  };
  
  export const litigationTypeDetailErrorAction = payload => {
    return {
      type: 'LITIGATIONTYPEDETALERROR',
      payload
    };
  };

  export const getLitigationTypeDetailListAPI = (payload, successData, errorMSg, headers = {}) => {
    return dispatch => {
      dispatch(getLitigationTypeDetailListRequest());
      return request(
        'POST',
        `${REACT_APP_API_URL + '/litigation-type-Detail-list'}`,
        payload,
        "",
        headers
      )
        .then(res => {
          if (res?.data.status === 200) {
            successData(res.data.data.litigationTypeDetailList);
            dispatch(getLitigationTypeDetailListSuccess(res.data.data.litigationTypeDetailList));
          } else {
            errorMSg(res);
          }
        })
        .catch(err => {
          errorMSg(err?.res);
          dispatch(getLitigationTypeDetailListFailure('Something went wrong'));
          throw err;
        });
    };
  };

  export const addLitigationTypeMasterDetailAPI = (payload, successData, errorMsg,header={}) => {
    return (dispatch) => {
        dispatch(addLitigationTypeMasterDetailRequest());
        return request("POST", `${REACT_APP_API_URL + "/add-litigation-type-detail"}`, payload,"",header)
            .then((response) => {
                if (response?.data?.status === 200) {
                    successData(response);
                    dispatch(addLitigationTypeMasterDetailSuccess(response));
                } else {
                    errorMsg(response);
                }
  
            }).catch((error) => {
                errorMsg(error?.response);
                dispatch(addLitigationTypeMasterDetailFailure ("Something Went Wrong"));
                throw error;
            });
    };
  };

  export const updateLitigationTypeMasterDetailAPI = (payload, successData, errorMsg,header={}) => {
    return (dispatch) => {
        dispatch(updateLitigationTypeMasterDetailRequest());
        return request("POST", `${REACT_APP_API_URL + "/update-litigation-type-detail"}`, payload,"",header)
            .then((response) => {
                if (response?.data?.status === 200) {
                    successData(response);
                    dispatch(updateLitigationTypeMasterDetailSuccess(response));
                } else {
                    errorMsg(response);
                }
  
            }).catch((error) => {
                errorMsg(error?.response);
                dispatch(updateLitigationTypeMasterDetailFailure("Something Went Wrong"));
                throw error;
            });
    };
  };